import Isotope from "isotope-layout";

class CongressLibrary {
  constructor() {
    this.congressLibrary = document.querySelector("[data-congress-library]");
    this.grid = this.congressLibrary.querySelector(".grid");

    this.resultWrapper =
      this.congressLibrary.querySelector("[data-obj='pubs']");
    this.resultCount = this.congressLibrary.querySelector("[data-count]");

    this.productFilter = this.congressLibrary.querySelector(
      "[data-product-list]",
    );
    this.therapeuticAreasFilter = this.congressLibrary.querySelector(
      "[data-therapy-area-list]",
    );
    this.keywordSearchFilter = this.congressLibrary.querySelector(
      "[data-keyword-search]",
    );

    this.filterResetButton = this.congressLibrary.querySelector(
      "[data-filter-clear-all]",
    );

    this.congressData = [];

    this.initFilters();

    //get congress data
    if (sessionStorage.getItem("congressData") === null) {
      //if congress data is not in session storage, fetch it
      fetch("/api/mira/v1/congresses")
        .then((response) => response.json())
        .then((data) => {
          sessionStorage.setItem("congressData", JSON.stringify(data));
          this.congressData = data;
          this.initIsotope();
        });
    } else {
      this.congressData = JSON.parse(sessionStorage.getItem("congressData"));
      this.initIsotope();
    }
  }

  /**
   * Initialize Isotope filtering functionality
   */
  initIsotope() {
    this.loadCongressesHTML();

    this.iso = new Isotope(this.grid, {
      itemSelector: ".grid-item",
      layoutMode: "vertical",
    });

    // Force Isotope to run one initial layout
    this.iso.arrange();

    this.iso.on("arrangeComplete", () => {
      this.resultCount.innerHTML = this.iso.filteredItems.length;
    });
  }

  /**
   * Initialize filters and their event listeners
   */
  initFilters() {
    this.filters = {
      therapeuticAreas: "*",
      products: "*",
      search: "",
    };

    this.productFilter.addEventListener("productSelected", (e) => {
      this.filters.products = e.product.name.toLowerCase();

      if (e.product.name.toLowerCase() === "all") {
        this.productFilter.querySelector(
          "button.dropdown-toggle span",
        ).innerHTML = `${
          this.productFilter
            .querySelector(".dropdown-menu")
            .getAttribute("data-default-label") || "Select a medicine"
        }`;
        this.filters.products = "*";
      }

      this.applyFilters();
    });

    this.therapeuticAreasFilter.addEventListener("therapyAreaSelected", (e) => {
      this.filters.therapeuticAreas = e.therapyArea.slug;

      if (e.therapyArea.slug === "*") {
        this.therapeuticAreasFilter.querySelector(
          "button.dropdown-toggle span",
        ).innerHTML = `${
          this.therapeuticAreasFilter
            .querySelector(".dropdown-menu")
            .getAttribute("data-default-label") || "Select a therapy area"
        }`;
        this.filters.therapeuticAreas = "*";
      }

      this.applyFilters();
    });

    this.keywordSearchFilter?.addEventListener("input", (e) =>
      this.keywordSearchHandler(e),
    );
    this.keywordSearchFilter?.addEventListener("search", (e) =>
      this.keywordSearchHandler(e),
    );

    this.filterResetButton.addEventListener("click", () => {
      //reset filters
      this.filters = {
        therapeuticAreas: "*",
        products: "*",
        search: "",
      };

      this.therapeuticAreasFilter.querySelector(
        "button.dropdown-toggle span",
      ).innerHTML = `${
        this.therapeuticAreasFilter
          .querySelector(".dropdown-menu")
          .getAttribute("data-default-label") || "Select a therapy area"
      }`;
      this.productFilter.querySelector(
        "button.dropdown-toggle span",
      ).innerHTML = `${
        this.productFilter
          .querySelector(".dropdown-menu")
          .getAttribute("data-default-label") || "Select a medicine"
      }`;
      this.keywordSearchFilter.value = "";

      this.applyFilters();
    });
  }

  /**
   * Load congresses html from congressData
   */
  loadCongressesHTML() {
    this.resultWrapper.innerHTML = this.congressData
      .map((congress) => {
        return `
          <div class="grid-item 
                      ${congress.therapeutic_areas.data
                        .map((area) => area.slug)
                        .join(" ")}
                      ${congress.products.data
                        .map((product) => product.slug)
                        .join(" ")}
                      ">
            <div class="card card--congress mb-4">
                <div class="card-body d-md-flex">
                    <div class="align-items-center col-12 col-md-9">
                        <h1 class="therapy-areas">
                          ${congress.therapeutic_areas.data
                            .map((area) => area.name)
                            .join(", ")}
                        </h1>
                        <h1 class="products">
                          ${congress.products.data
                            .map((product) => {
                              return (
                                product.title +
                                "<sup>" +
                                product.symbol +
                                "</sup>"
                              );
                            })
                            .join(", ")}
                        </h1>
                        <h2>${congress.title}</h2>
                        <h4>${congress.subtitle}</h4>
                        <p>Publications: <strong>${
                          congress.publications_count
                        }</strong></p>
                    </div>
                    <a class="d-flex align-items-center col-12 col-md-3" href="${
                      congress.permalink
                    }">
                        <span>
                          <button class="btn" type="button" data-action="view" data-icon-arrow-right>
                            <span>View</span>
                          </button>
                        </span>
                    </a>
                </div>
            </div>
          </div>
      `;
      })
      .join("");
  }

  /**
   * Apply filters based on user selections
   */
  applyFilters() {
    this.iso.arrange({
      filter: (itemElem) => {
        // Support both callback shapes: DOM Element and Isotope item wrapper ({ element }).
        const elem =
          itemElem && itemElem.nodeType === 1 ? itemElem : itemElem?.element;
        if (!elem || !elem.classList) {
          return false;
        }

        const text = (elem.textContent || "").toLowerCase();
        const searchText = (this.filters.search || "").toLowerCase();

        const matchestherapeuticAreas =
          this.filters.therapeuticAreas === "*" ||
          elem.classList.contains(this.filters.therapeuticAreas);

        const mathchesProducts =
          this.filters.products === "*" ||
          elem.classList.contains(this.filters.products);

        const matchesSearch = text.includes(searchText);

        return matchesSearch && matchestherapeuticAreas && mathchesProducts;
      },
    });
  }

  /**
   * Keyword search input handler
   *
   * @param {*} e
   */
  keywordSearchHandler(e) {
    this.filters.search = e.target.value;
    this.applyFilters();
  }
}

new CongressLibrary();
